<app-wizard-modal
    [isLoading]="isLoading"
    (cancel)="onWizardCancel()"
    (stepChange)="onStepChange($event)"
    (submit)="onWizardSubmit()"
>
    <app-wizard-title>{{'admin.lifts.batches.copyBatches' | translate}}</app-wizard-title>

    <app-wizard-step>
        <ng-template #title>{{'admin.lifts.batches.selectBatches' | translate}}</ng-template>
        <ng-template #content let-step="step">
            <app-select-batches-form
                [availableBatches]="availableBatches"
            ></app-select-batches-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step>
        <ng-template #title>{{'admin.lifts.batches.selectLocation' | translate}}</ng-template>
        <ng-template #content let-step="step">
            <app-select-slot-form
                [initialLiftId]="initialLiftId"
                [initialTrayId]="initialLiftId"
            ></app-select-slot-form>
        </ng-template>
    </app-wizard-step>
</app-wizard-modal>
